import './index.less';

import ProjectIngestionPipeline from './ProjectIngestionPipeline';
import ProjectWidget from './ProjectWidget';
import ProjectSearchPipeline from './ProjectSearchPipeline';
import Tracing from './Tracing';
import AgentGeneral from './AgentGeneral';
import ProjectAgentTools from './ProjectAgentTools';
import AgentWidget from './AgentWidget';
import ELMA365ToolMain from './elma365Toolkit/tool/ELMA365ToolMain';
import ELMA365ToolJSONSchema from './elma365Toolkit/tool/ELMA365ToolJSONSchema';

type SettingsSubComponents = {
  ProjectSearchPipeline: typeof ProjectSearchPipeline;
  ProjectIngestionPipeline: typeof ProjectIngestionPipeline;
  Tracing: typeof Tracing;
  ProjectWidget: typeof ProjectWidget;
  AgentGeneral: typeof AgentGeneral;
  AgentWidget: typeof AgentWidget;
  ProjectAgentTools: typeof ProjectAgentTools;
  ELMA365ToolMain: typeof ELMA365ToolMain;
  ELMA365ToolJSONSchema: typeof ELMA365ToolJSONSchema;
};

const Settings: SettingsSubComponents = () => null;

Settings.ProjectSearchPipeline = ProjectSearchPipeline;
Settings.ProjectIngestionPipeline = ProjectIngestionPipeline;
Settings.Tracing = Tracing;
Settings.ProjectWidget = ProjectWidget;
Settings.AgentGeneral = AgentGeneral;
Settings.AgentWidget = AgentWidget;
Settings.ProjectAgentTools = ProjectAgentTools;
Settings.ELMA365ToolMain = ELMA365ToolMain;
Settings.ELMA365ToolJSONSchema = ELMA365ToolJSONSchema;

export default Settings;
